(function () {
    'use strict';

    angular.module("imApp").factory("priceIndexesService", [function () {
        let service = {};

        return service;
    }]);
})();
